import gsap from 'gsap';
import { asyncAjaxCall } from './utils';
import { cartClass, loaderClass, scrollInstance, toastInstance } from './main';

class Cart {
	constructor(){
		this.cart = document.querySelector('.cart--component');
		this.isOpen = false;
		this.isAnimating = false;
		this.toastMessage = toastInstance;
		this.gotToCheckout = this.cart.querySelector('.cagliari--checkout');

		this.init()
	}
	init() {
		this.cart.querySelector('.cart--gradient-bg').addEventListener('click', () => {
			this.close()
		})
		this.cart.querySelector('.close--cart').addEventListener('click', () => {
			this.close()
		})

		this.gotToCheckout.addEventListener('click', () => {
			this.checkout()
		});
	}
	async addToCart(payload){
        const response = await fetch(custom_ajax_obj.url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(payload),
        });
        const data = await response.json();
		this.updateHeaderCart(data.data.count)
        this.open()
	}
	loader(action){
		if(action == 'open'){
			gsap.to(this.cart.querySelector('.cart--loader'), { duration: .5, autoAlpha: 1, ease: 'power4.inOut' })
		}else{
			gsap.to(this.cart.querySelector('.cart--loader'), { duration: .5, autoAlpha: 0, ease: 'power4.inOut' })
		}
	}
	async open() {
		if(this.isOpen || this.isAnimating) return;
		scrollInstance.stop()
		this.isAnimating = true;
		if(!loaderClass.isLoaderOpen) loaderClass.open();
		if(!loaderClass.isLoaderOpen && loaderClass.icon) loaderClass.switch();
		await this.populate()
		gsap.to(this.cart, { duration: 0, autoAlpha: 1 })
		gsap.to(this.cart.querySelector('.cart--container'), { duration: 1, x: 0, ease: 'power4.inOut', onComplete: () => {
			this.isAnimating = false;
			this.isOpen = true;
		}})
	}
	async close() {
		if(!this.isOpen || this.isAnimating) return;
		this.isAnimating = true;
		gsap.to(this.cart.querySelector('.cart--container'), { duration: 1, x: '100%', ease: 'power4.inOut', onComplete: () => {
			this.isAnimating = false;
			this.isOpen = false;
			
			loaderClass.close();
			
			gsap.to(this.cart, { duration: 0, autoAlpha: 0 })
			if(!document.querySelector('.franclizer--product-buy-component') || !document.querySelector('.franclizer--product-buy-component').classList.contains('open-directly')){
				scrollInstance.start()
			}
			
		}})
	}
	async populate(){
		const response = await fetch(custom_ajax_obj.url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
				action:           'cart_get',
				security:         custom_ajax_obj.security,
			}),
        });
        const data = await response.json();
		
		this.cart.querySelector('.cart--container .cart--wrapper .cart--items .items-scroll').innerHTML = data.data.html;
		this.cart.querySelector('.cart--container .cart--wrapper .cart--recap .top .right span').innerHTML = '€' + data.data.total['formatted'];


		this.setQuantityVariations()
		this.cart.querySelectorAll('.cart--container .cart--wrapper .cart--items .cart--item').forEach((item) => {
			let remove = item.querySelector('.delete-item');
			remove.addEventListener('click', () => {
				let key = remove.getAttribute('key');
				this.loader('open')
				this.removeProduct(key).then((res) => {
					document.querySelector('.cart--items .cart--item[data-item-id="' + key + '"]').remove()
					this.updateHeaderCart(res.data.count)
					this.loader('close')
					if(res.data.count == 0) this.close()
				})
			})
		})
	}
	setQuantityVariations(){
		this.cart.querySelectorAll('.cart--container .cart--wrapper .cart--items .cart--item').forEach((item) => {
			let timeout;
			let less = item.querySelector('.variations--quantity .qty-btn--minus');
			let more = item.querySelector('.variations--quantity .qty-btn--plus');

			less.addEventListener('click', () => {
				clearTimeout(timeout);
				let minValue = parseInt(item.querySelector('.variations--quantity .qty-input').getAttribute('min'));
				let quantity = parseInt(item.querySelector('.variations--quantity .qty-input').value);

				if(quantity >= 1){
					if(quantity > minValue) quantity--;
					item.querySelector('.variations--quantity .qty-input').value = quantity;
					item.querySelector('.right-total span em').innerHTML = this.getItemPrice(item.querySelector('.variations--quantity .qty-input').getAttribute('price')*100, quantity)

					timeout = setTimeout(() => {
						this.loader('open')
						this.updateProductQuantity(item.getAttribute('data-item-id'), quantity).then(() => this.loader('close'))
					}, 500)
				}
			})
			more.addEventListener('click', () => {
				clearTimeout(timeout);
				let quantity = parseInt(item.querySelector('.variations--quantity .qty-input').value);
				let limit = item.querySelector('.variations--quantity .qty-input').getAttribute('quantity');

				if(limit == 'over') limit = 999;
				else limit = parseInt(limit);

				if(quantity <= limit){
					if(quantity < limit) quantity++;
					item.querySelector('.variations--quantity .qty-input').value = quantity;
					item.querySelector('.right-total span em').innerHTML = this.getItemPrice(item.querySelector('.variations--quantity .qty-input').getAttribute('price')*100, quantity)

					timeout = setTimeout(() => {
						this.loader('open')
						this.updateProductQuantity(item.getAttribute('data-item-id'), quantity).then(() => this.loader('close'))
					}, 500)
				}
			})
		})
	}
	getItemPrice(price, quantity){
		return parseFloat((price * quantity/100)).toFixed(2);
	}
	async updateProductQuantity(key, quantity) {
		const response = await fetch(custom_ajax_obj.url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
				action:           'cart_update',
				security:         custom_ajax_obj.security,
				item_id:              key,
				quantity:              quantity,
			}),
        });
		const res = await response.json();
		this.cart.querySelector('.cart--container .cart--wrapper .cart--recap .top .right span').innerHTML = '€' + res.data.total['formatted'];
		this.updateHeaderCart(res.data.count)
	}
	updateHeaderCart(quantity){
		document.querySelectorAll('.total-cart-update').forEach((el) => {
			el.querySelector('span').innerHTML = quantity;
		})
	}
	async removeProduct(key){
		const response = await fetch(custom_ajax_obj.url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
				action:           'cart_remove',
				security:         custom_ajax_obj.security,
				item_id:              key,
			}),
        });
		const data = await response.json();

		this.cart.querySelector('.cart--container .cart--wrapper .cart--recap .top .right span').innerHTML = '€' + data.data.total['formatted'];
		return data;
	}
	async checkout() {
		this.loader('open')
		try {
			const res = await fetch(custom_ajax_obj.url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: new URLSearchParams({
					action:   'create_checkout_session',
					security: custom_ajax_obj.security,
				}),
			});

			const data = await res.json();

			if (data.success) {
				window.location.href = data.data.url; // redirect a Stripe
			} else {
				console.error(data.data.message);
			}
		} catch (err) {
			console.error('Errore di rete');
		}
	}
}

export { Cart };